<template>
    <div class="t_dropdown listing-options">
        <div class="t_dropdown__label" @click.stop="showDropdown = !showDropdown">
            <img src="/img/dropdown-vertical-dots.svg" alt="">
        </div>
        <div class="t_dropdown__menu" v-bind:class="{ t_show: showDropdown }" v-if="showDropdown" v-click-outside="onClickOutside">
            <template v-if="is_published">
            <a @click.prevent="unpublishListing()"><p>{{ $t('dashboard.unpublish') }}</p></a>
            </template>
            <a @click.prevent="duplicateListing()"><p>{{ $t('dashboard.duplicate') }}</p></a>
            <a @click.prevent="deleteListing()"><p class="text-alert">{{ $t('dashboard.delete') }}</p></a>
        </div>
    </div>
</template>

<script>
    const DELETE_LISTING = 'delete_listing';
    const UNPUBLISH_LISTING = 'unpublish_listing';
    const DUPLICATE_LISTING = 'duplicate_listing';

    export default {
        props: {
            listing_id: Number,
            is_published: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showDropdown: false
            }
        },
        methods: {
            onClickOutside() {
                if (this.showDropdown) {
                    this.showDropdown = false;
                }
            },
            deleteListing() {
                this.$root.$emit('show_confirmation', {
                    'title': this.$t('dashboard.delete_website'),
                    'description': this.$t('dashboard.delete_text'),
                    'type': DELETE_LISTING,
                    'data': {
                        'id': this.listing_id
                    },
                    'button_text': this.$t('dashboard.delete')
                });
            },
            unpublishListing() {
                this.$root.$emit('show_confirmation', {
                    'title': this.$t('dashboard.unpublish_website'),
                    'description': this.$t('dashboard.unpublish_text'),
                    'type': UNPUBLISH_LISTING,
                    'data': {
                        'id': this.listing_id
                    },
                    'button_text': this.$t('dashboard.unpublish')
                });
            },
            duplicateListing() {
                this.$root.$emit('show_confirmation', {
                    'title': this.$t('dashboard.duplicate_listing'),
                    'description': this.$t('dashboard.duplicate_text'),
                    'type': DUPLICATE_LISTING,
                    'data': {
                        'id': this.listing_id
                    },
                    'button_text': this.$t('dashboard.duplicate')
                });
            }
        }
    }
</script>
